import React from 'react'
import styled from 'styled-components'
import emojis from './emojis.json'

export type EmojiType = 'fire' | 'red-heart' | 'ok-hand'

interface IProps {
  type: EmojiType
}

const EmojiContainer = styled.span`
  font-size: inherit;
  display: inline-block;
  margin-right: 3px;
`

const Emoji = ({ type }: IProps) => {
  const emoji = emojis[type]

  if (!emoji) {
    return null
  }

  return (
    <EmojiContainer
      role="image"
      aria-label={type}
      dangerouslySetInnerHTML={{ __html: emoji }}
    />
  )
}

export default Emoji
